import { render, staticRenderFns } from "./SquareFacebookIcon.vue?vue&type=template&id=8360ae1c&"
import script from "./SquareFacebookIcon.vue?vue&type=script&lang=js&"
export * from "./SquareFacebookIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports